export default "/images/1d4d6291fe5f79a71dac0eb0cb544263.avif";